<template>
  <div>
    <HeaderEFTG portal="OAM Portal" :showAuth="false" ref="headerEFTG"></HeaderEFTG>
    <div class="container">
      <h2>Richlist</h2>
      <div v-if="richlist.length > 0">
        <sorted-table :values="richlist">
          <thead>
            <tr class="table-primary">
              <th scope="col">#</th>
              <th scope="col" style="color:white">
                <sort-link name="name">Account</sort-link>
              </th>
              <th scope="col">
                <sort-link name="balance">Balance</sort-link>
              </th>
              <th scope="col">
                <sort-link name="savings">Savings</sort-link>
              </th>
              <th scope="col">
                <sort-link name="bp">Blurt Power</sort-link>
              </th>
              <th scope="col">
                <sort-link name="delegationOut">Delegation Out</sort-link>
              </th>
              <th scope="col">
                <sort-link name="delegationIn">Delegation In</sort-link>
              </th>
              <th scope="col">
                <sort-link name="withdrawRate">Power Down</sort-link>
              </th>
              <th scope="col">
                <sort-link name="totalAccountBp">Effective BP</sort-link>
              </th>
              <th scope="col">
                <sort-link name="totalValue">Account Value USD</sort-link>
              </th>
              <!-- <th scope="col">Vote</th> -->
            </tr>
          </thead>
          <tbody slot="body" slot-scope="sort">
            <tr v-for="rich in sort.values" :key="rich.name">
              <td>{{ rich.num }}</td>
              <td>
                <a :href="BLOG_URL+'@'+rich.name" target="_blank">
                <div
                  v-bind:style="{ backgroundImage: 'url(' + rich.imgUrl + ')' }"
                  class="image-profile mr-2"
                ></div>
                </a>
                <router-link :to="EXPLORER+'@'+rich.name">{{ rich.name }}</router-link>
              </td>
              <td>{{ rich.balance.toFixed(3) }} BLURT</td>
              <td>{{ rich.savings.toFixed(3) }} BLURT</td>
              <td>{{ rich.bp.toFixed(3) }} BP</td>
              <td>{{ rich.delegationOut.toFixed(3) }} BP</td>
              <td>{{ rich.delegationIn.toFixed(3) }} BP</td>
              <td v-if="rich.diff===''">{{ rich.withdrawRate.toFixed(3) }} BP</td>
              <td v-else>{{ rich.withdrawRate.toFixed(3) }} BP in {{rich.diff}}</td>
              <td>{{ rich.totalAccountBp.toFixed(3) }} BP</td>
              <td>${{ rich.totalValue.toFixed(2) }}</td>
            </tr>
          </tbody>
        </sorted-table>
      </div>
      <div v-else>
        <div class="loader"></div>
      </div>
      <div v-if="alert.info" class="alert alert-info" role="alert">{{alert.infoText}}</div>
      <div v-if="alert.success" class="alert alert-success" role="alert" v-html="alert.successText"></div>
      <div v-if="alert.danger" class="alert alert-danger" role="alert">{{alert.dangerText}}</div>
    </div>
  </div>
</template>

<script>
// import debounce from "lodash.debounce";

import BlurtClient from "@/mixins/BlurtClient.js";
import axios from "axios";

import Config from "@/config.js";
import Utils from "@/js/utils.js";
import ChainProperties from "@/mixins/ChainProperties.js";
import HeaderEFTG from "@/components/HeaderEFTG";

export default {
  name: "Richlist",

  data() {
    return {
      richlist: [],
      EXPLORER: Config.EXPLORER,
      BLOG_URL:Config.BLOG_URL,
    };
  },

  components: {
    HeaderEFTG,
  },
  mixins: [ChainProperties, BlurtClient],

  created() {
    this.getRichlist();
  },

  methods: {
    async getRichlist() {
      try {
        const price = await this.getBlurtPrice();
        const response = await axios.get("https://biapi.blurtopian.com/api/richlist?start=0&limit=500&sort_by=total_value&sort_dir=desc");
        if (response.status === 200) {
          let accounts = response.data.data;
          let count = 1;
          for (let account of accounts) {
            let diff='';
            if (account.next_vesting_withdrawal !== "1969-12-31T23:59:59.000Z") {
              diff =
                Utils.textTime( new Date(account.next_vesting_withdrawal) - new Date());
            }
            this.richlist.push({
              num: count++,
              name: account.name,
              imgUrl: `https://imgp.blurt.blog/profileimage/${account.name}/64`,
              balance: account.balance,
              savings: account.savings_balance,
              bp: this.vests2bpFloat(account.vesting_shares),
              delegationOut: this.vests2bpFloat(account.delegated_vesting_shares),
              delegationIn: this.vests2bpFloat(account.received_vesting_shares),
              withdrawRate: this.vests2bpFloat(account.vesting_withdraw_rate),
              totalAccountBp: this.vests2bpFloat(account.vesting_shares + account.received_vesting_shares - account.delegated_vesting_shares),
              totalValue: Math.round((account.balance + account.savings_balance + account.vesting_shares) * price * 100) / 100,
              diff
            });
          }
        }
      } catch (error) {
        console.error(`Failed to fetch richlist: ${error}`);
      }
    },
    async getBlurtPrice() {
      return new Promise(async (resolve) => {
        try {
          const response = await axios.get(
            "https://api.blurt.blog/price_info"
          );
          if (response.status === 200) {
            let price = response.data.price_usd;
            resolve(price);
          }
        } catch (error) {
          console.error(`Failed to fetch BLURT price: ${error}`);
        }
      });
    },
  },
};
</script>

<style scoped>
.image-profile {
  display: inline-block;
  height: 2rem;
  width: 2rem;
  overflow: hidden;
  background-size: cover;
  background-position: center center;
  border-radius: 50%;
  vertical-align: middle;
}

.circle {
  border: 2px solid;
  border-radius: 50%;
  width: 12px;
  height: 12px;
}

.enabled {
  border-color: green;
}

.disabled {
  border-color: red;
}

.table > tbody > tr > td {
  vertical-align: middle;
}

.vests {
  font-family: monospace;
  font-size: 1rem;
  margin: auto;
  text-align: right;
}
a {
  color: black;
}
</style>
